import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import { getDecoration } from '../forms';

import styles from '../styles/formDecoration.module.scss';

const FormDecoration = ({
  className = '',
  fieldId = '',
  fieldKey = '',
  form,
  model,
  schema,
  type,
  variant = 'default',
}) => {
  const FormDecorationComponent = getDecoration(type);

  if (!FormDecorationComponent) {
    console.warn(`You're trying to render a form decoration (${type}) that has not been registered. Look at the schema for ${fieldKey}`);
    return null;
  }

  return (
    <div className={classnames(styles.element, className)}>
      <FormDecorationComponent
        model={model}
        variant={variant}
        schema={schema}
        fieldId={fieldId}
        fieldKey={fieldKey}
        form={form}
      />
    </div>
  );
};

FormDecoration.propTypes = {
  model: PropTypes.shape({}).isRequired,
  variant: PropTypes.string,
  type: PropTypes.string.isRequired,
  className: PropTypes.string,
  fieldId: PropTypes.string,
  fieldKey: PropTypes.string,
  form: PropTypes.shape({}).isRequired,
  schema: PropTypes.shape({}).isRequired,
};

export default React.memo(FormDecoration);
